module.exports = __webpack_public_path__ + "img/Préparation cadre pour mezzanine.9d9f9698.jpg";